import React, {Component} from "react";
import moment from "moment-timezone";
import {Alert, Checkbox, ClickAwayListener, FormControlLabel, Grid, IconButton, InputAdornment, ListItemIcon, ListItemText, Menu, MenuItem, Popper, Switch, TextField, Typography} from "@mui/material";
import {Check, CheckCircle, Error, FilterAltOutlined, Help, ListAlt, Visibility, VisibilityOff} from "@mui/icons-material";
import spinner from "../assets/Spinner-1s-200px.svg";
import CCInputPhone from "./Common/CCInputPhone";
import CCInputInteger from "./Common/CCInputInteger";
import CCInputFloat from "./Common/CCInputFloat";
import CCDateTimePicker from "./Common/CCDateTimePicker";
import CCDatePicker from "./Common/CCDatePicker";
import * as validators from "../util/Validators";
import css_self from "./Common/css/EnlilDetail.module.scss";
import css_button from "./Common/css/CCButton.module.scss";
import EnlilSelect from "./EnlilSelect";
import {updateObject} from "../util/utility";
import EnlilMultiSelect from "./EnlilMultiSelect";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../util/Buffer";
import {Grey6} from "../theme/styles";
import UniqueValidator from "../eoec/util/UniqueValidator";
import EnlilLongSelect from "./EnlilLongSelect";
import EventBus from "../util/EventBus";


class EnlilDetail extends Component {
    state = {
        fetchBackgroundOperation: false,
        filtering: false,
        controls: null,
        errors: {},
        saveAndAddNew: false,
        previousValues: {},
        updateBackgroundOperation: false,
        insertBackgroundOperation: false,
        queryBackgroundOperation: false,
        deleteBackgroundOperation: false,
        errorReportingMethod: "RealTime",
        showErrors: true,
        showPassword: false,
        groupCounter: 1,
        showAddAnother: false,
        patientNotificationOptionalChecked: true,
        initialModification: false,
        showInitialModificationWarning: false,
        helpAnchor: null,
        helpFormElementID: null,
        performConfirmOnSave: false,
        menu: null,
        action: null,
        showLongSelect: false,
        longSelectPickList: null,
        longSelectAttribute: null,
        longSelectFormElementId: null,
        confirmOnSave: this.props.options && this.props.options.ConfirmOnSave === true,
    };

    constructor(props) {
        super(props);

        this.applet = props.applet;
        this.state.action = props.action;

        this.timer = null;
    }

    blurHandler(event, formElementId) {
        if (this.state.controls[formElementId].requiresConfirmation !== true) return;
        if (this.state.controls[formElementId].valid === false) return;
        if (this.state.controls[formElementId].touched === false) return;
        if (this.state.controls[formElementId].confirmedValue === this.state.controls[formElementId].value) return;

        let original_value = this.applet.getEnterpriseComponent().getAttributeValue(this.props.controls[formElementId].enterpriseComponentAttribute, "original");

        let field = this.state.controls[formElementId];

        let err = field["errors"];

        let cumulativeErrors = {...this.state.errors};

        for (let i = 0; i < err.length; i++) {
            let testCase = err[i];

            if (testCase.validator === "Unique") {
                if (this.state.controls[formElementId].value !== "" && this.state.controls[formElementId].confirmedValue !== event.target.value && original_value !== this.state.controls[formElementId].value) {
                    this.validatorUnique(event.target.value, formElementId);
                }
                delete cumulativeErrors[field.id + "_" + testCase.validator];
            }
        }

        this.setState({errors: cumulativeErrors});

        return true;
    };

    cancel1Handler = (event, _) => {
        if (this.state.action === "View") {
            this.applet.cancel();
        } else if (this.state.action === "Query") {
            this.applet.cancel();
        } else if (this.isFormTouched()) {
            event.preventDefault();
            this.setState({showConfirmation: true});
        } else {
            this.applet.cancel();
        }
    };

    cancel2Handler = (event) => {
        event.preventDefault();
        this.setState({errors: {}, showConfirmation: false});
        this.applet.cancel();
    };

    checkValidity(formElementId, value) {
        let check = {};

        let values = {};
        let keys = Object.keys(this.state.controls);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key === formElementId) {
                values[key] = value;
            } else {
                values[key] = this.state.controls[key].value;
            }
        }
        let cumulativeErrors = {...this.state.errors};

        for (let t = 0; t < keys.length; t++) {
            let formElementToTestId = keys[t];

            let field = this.state.controls[formElementToTestId];
            let err = field["errors"];
            if (err === undefined) {
                err = {};
            }
            let attribute = this.applet.getEnterpriseComponent().getAttribute(field.enterpriseComponentAttribute);

            if (formElementId === formElementToTestId) {
                let touched = true;
                if (this.state.action === "Query" && values[formElementToTestId].length === 0) {
                    touched = false
                }
                check[formElementToTestId] = {
                    ...field,
                    touched: touched,
                    value: values[formElementToTestId],
                    valid: true,
                };
            } else {
                let touched = this.state.controls[formElementToTestId].touched;
                if (this.state.action === "Query" && values[formElementToTestId].length === 0) {
                    touched = false
                }

                check[formElementToTestId] = {
                    ...field,
                    touched: touched,
                    value: values[formElementToTestId],
                    valid: true,
                };
            }

            for (let i = 0; i < err.length; i++) {
                let testCase = err[i];
                let localCheck = true;

                if (testCase.validator === "Required") {
                    localCheck = validators.Required(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "No Leading Zeros") {
                    localCheck = validators.NoLeadingZeros(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "No Leading Spaces") {
                    localCheck = validators.NoLeadingSpaces(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "No Trailing Spaces") {
                    localCheck = validators.NoTrailingSpaces(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Minimum") {
                    localCheck = validators.Minimum(values[formElementToTestId], attribute.getMinLength());
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Maximum") {
                    localCheck = validators.Maximum(values[formElementToTestId], attribute.getLength());
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "No Special Characters") {
                    localCheck = validators.NoSpecialCharacters(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "No Spaces") {
                    localCheck = validators.NoSpaces(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Maximum Value") {
                    localCheck = validators.MaximumValue(values[formElementToTestId], testCase.value);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Minimum Value") {
                    localCheck = validators.MinimumValue(values[formElementToTestId], testCase.value);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Required Integer") {
                    localCheck = validators.RequiredInteger(values[formElementToTestId]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Required Pattern") {
                    if (values[formElementToTestId] === null) {
                        localCheck = false;
                    } else {
                        localCheck = validators.RequiredPattern(values[formElementToTestId], attribute.getPattern());
                    }
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Optional Pattern") {
                    localCheck = validators.OptionalPattern(values[formElementToTestId], attribute.getPattern());
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Float") {
                    localCheck = isNaN(Number(values[formElementToTestId])) !== true;
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Numbers Only") {
                    localCheck = validators.NumbersOnlyPattern(values[formElementToTestId], attribute.getPattern());
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Match Values") {
                    localCheck = validators.MatchValues(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "All Or None") {
                    localCheck = validators.AllOrNone(values[formElementToTestId], testCase.fields.map(x => values[x]));
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Either Values") {
                    localCheck = validators.EitherValues(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Either Values Not NULL") {
                    localCheck = validators.EitherValuesNotNULL(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "One Field Must Be Provided") {
                    localCheck = validators.OneFieldMustBeProvided(testCase.field, values, this.state.controls);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "One Checkbox Must Be True") {
                    localCheck = validators.OneCheckboxMustBeTrue(testCase.field, values);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Is Same Or Before Day") {
                    localCheck = validators.IsSameOrBeforeDay(values[formElementToTestId], testCase.value ?? values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Is Same Or After Day") {
                    localCheck = validators.IsSameOrAfterDay(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Cannot Match Values") {
                    localCheck = validators.CannotMatchValues(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Cannot Match Values - Case Insensitive") {
                    localCheck = validators.CannotMatchValuesCaseInsensitive(values[formElementToTestId], values[testCase.field]);
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Not All Spaces") {
                    if (values[formElementToTestId].length === 0) {
                        localCheck = true;
                    } else localCheck = values[formElementToTestId].trim().length !== 0;
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                } else if (testCase.validator === "Unique") {
                    check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                }

                check[formElementToTestId].hasBeenConfirmed = this.state.controls[formElementToTestId].hasBeenConfirmed;
                if (this.state.controls[formElementToTestId].requiresConfirmation === true) {
                    if (this.state.controls[formElementToTestId].confirmedValue !== values[formElementToTestId]) {
                        check[formElementToTestId].hasBeenConfirmed = false;
                        check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                    } else if (this.state.controls[formElementToTestId].hasBeenConfirmed === false && values[formElementToTestId] !== "") {
                        check[formElementToTestId].valid = false;
                    }
                }

                if (this.state.controls[formElementToTestId].requiresConfirmation) {
                    if (values[formElementToTestId] === "") {
                        check[formElementToTestId].hasBeenConfirmed = false;
                        check[formElementToTestId].valid = check[formElementToTestId].valid && localCheck;
                    }
                }

                if (localCheck === false) {
                    if (this.props.errorReportingMethod === "SubmitTime") {
                        cumulativeErrors[field.id + "_" + testCase.validator] = testCase.errorText;
                    } else {
                        if (check[formElementToTestId].touched === true) {
                            cumulativeErrors[field.id + "_" + testCase.validator] = testCase.errorText;
                        }
                    }
                } else {
                    if (testCase.validator !== "Unique") {
                        delete cumulativeErrors[field.id + "_" + testCase.validator];
                    }
                }
            }
        }
        this.setState({errors: cumulativeErrors});

        return check;
    };

    componentDidMount() {

        EventBus.components.addListener("long-select-cancel", this.onLongSelectCancelHandler);
        EventBus.components.addListener("long-select-select", this.onLongSelectSelectHandler);

        this.applet.getEnterpriseComponent().addRecordChangedListener(this);
        this.applet.getEnterpriseComponent().addPickCompletedListener(this);
        this.applet.getEnterpriseComponent().addLoadStartedListener(this);
        this.applet.getEnterpriseComponent().addLoadCompletedListener(this);
        this.applet.getEnterpriseComponent().addDeleteStartedListener(this);
        this.applet.getEnterpriseComponent().addDeleteCompletedListener(this);
        this.applet.getEnterpriseComponent().addUpdateStartedListener(this);
        this.applet.getEnterpriseComponent().addUpdateCompletedListener(this);
        this.applet.getEnterpriseComponent().addInsertStartedListener(this);
        this.applet.getEnterpriseComponent().addInsertCompletedListener(this);
        this.applet.getEnterpriseComponent().addInsertRollbackCompletedListener(this);
        this.applet.getEnterpriseComponent().addUpdateRollbackCompletedListener(this);
        this.applet.getEnterpriseComponent().addModeChangedListener(this);
        this.applet.getEnterpriseComponent().addNewQueryRecordListener(this);
        this.applet.getEnterpriseComponent().addNewRecordListener(this);
        this.applet.getEnterpriseComponent().addNewEditRecordListener(this);
        this.applet.getEnterpriseComponent().addNewDeleteRecordListener(this);
        this.applet.getEnterpriseComponent().addInvalidListener(this);

        this.applet.setAction(this.props.action);

        if (this.props.action === "Edit") {
            this.applet.getEnterpriseComponent().setMode(EnterpriseComponent.MODE_UPDATE);
        }
    }

    componentWillUnmount() {
        this.applet.getEnterpriseComponent().removeAllListeners(this);

        EventBus.components.removeListener("long-select-cancel", this.onLongSelectCancelHandler);
        EventBus.components.removeListener("long-select-select", this.onLongSelectSelectHandler);
    }

    enterpriseComponentInvalidated(ec) {
    }

    enterpriseComponentNewQueryRecordStarted(ec) {
    }

    enterpriseComponentNewRecordStarted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        this.prepareLocalState(buffer[0]);
    };

    enterpriseComponentNewEditRecordStarted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        if (buffer.length > 0) {
            this.prepareLocalState(buffer[0]);
        }
    };

    enterpriseComponentNewDeleteRecordStarted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        if (buffer.length > 0) {
            this.prepareLocalState(buffer[0]);
        }
    };

    enterpriseComponentInsertStarted = () => {
        this.setState({insertBackgroundOperation: true});
    };

    enterpriseComponentInsertCompleted = (ec) => {
        let controls = this.makeControls().controls;

        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);

        if (buffer.length > 0) {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                controls[key]["value"] = buffer[0][key] === null ? "" : buffer[0][key];
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
            }
        }
        if (this.state.saveAndAddNew) {
            this.applet.setAction("New");

            if (buffer.length > 0) {
                this.prepareLocalState(buffer[0]);
            }
        } else {
            this.applet.setAction("Save Completed");
        }

        this.setState({controls: controls, errors: {}, insertBackgroundOperation: false});
    };

    enterpriseComponentInsertRollbackCompleted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        if (buffer.length > 0) {
            this.setState({buffer: buffer[0], fetchBackgroundOperation: false});
            this.prepareLocalState(buffer[0]);
        } else {
            this.setState({buffer: [], fetchBackgroundOperation: false});
        }
    };

    enterpriseComponentLoadStarted = () => {
        this.setState({fetchBackgroundOperation: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        this.setState({buffer: buffer[0], fetchBackgroundOperation: false});
        this.prepareLocalState(buffer[0]);
    };

    enterpriseComponentPickCompleted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        let row = buffer[0];

        let controls = structuredClone(this.state.controls);
        let keys = Object.keys(controls);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];

            if (controls[key]["csp"] === undefined) {
                controls[key]["csp"] = {};
            }
            if (controls[key]["ip"] === undefined) {
                controls[key]["ip"] = {};
            }

            let value = row.get(controls[key].enterpriseComponentAttribute) === null || row.get(controls[key].enterpriseComponentAttribute) === undefined ? "" : row.get(controls[key].enterpriseComponentAttribute);
            controls[key]["value"] = typeof value === "boolean" ? value : value.toString();
            controls[key]["valid"] = true;
            controls[key]["touched"] = false;
            controls[key]["showSpinner"] = false;
            controls[key]["passwordVisible"] = false;

            if (controls[key].enterpriseComponentAttribute !== null) {
                let attribute = this.applet.getEnterpriseComponent().getAttribute(controls[key].enterpriseComponentAttribute);
                if (attribute !== undefined) {
                    if (attribute.getLength() !== null) {
                        controls[key]["ip"]["maxLength"] = attribute.getLength();
                    }
                    if (attribute.getNoUpdate() !== null) {
                        if (controls[key]["csp"]["disabled"] === undefined) {
                            controls[key]["csp"]["disabled"] = attribute.getNoUpdate();
                        }
                        controls[key]["ip"]["readOnly"] = attribute.getNoUpdate();
                    }
                    if (attribute.getRequired() === true) {
                        let found = false;
                        for (let t = 0; t < controls[key]["errors"].length; t++) {
                            let err = controls[key]["errors"][t];
                            if (err.validator === "Required") found = true;
                        }
                        if (!found) {
                            controls[key]["errors"].push({
                                validator: "Required",
                                value: null,
                                errorText: "Field must contain a value.",
                            });
                        }
                    }
                }
            }

            if (controls[key]["requiresConfirmation"]) {
                controls[key]["hasBeenConfirmed"] = true;
                controls[key]["confirmedValue"] = value.toString();
            }
        }
        this.setState({buffer: buffer[0], controls: controls});
    };

    enterpriseComponentRecordChanged = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);
        this.setState({buffer: buffer[0]});
        this.prepareLocalState(buffer[0]);
    };

    enterpriseComponentModeChanged = (ec) => {};

    enterpriseComponentUpdateStarted = () => {
        this.setState({updateBackgroundOperation: true});
    };

    enterpriseComponentDeleteStarted = () => {
        this.setState({deleteBackgroundOperation: true});
    };

    enterpriseComponentDeleteCompleted(ec) {
        let buffer = prepareBuffer(ec);
        let controls = this.makeControls().controls;

        if (buffer.length > 0) {
            buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);

            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                controls[key]["value"] = buffer[0][key] === null ? "" : buffer[0][key];
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
            }
        }

        this.applet.setAction("Save Completed");

        this.setState({controls: controls, errors: {}, deleteBackgroundOperation: false});
    };

    enterpriseComponentUpdateCompleted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);

        let controls = this.makeControls().controls;

        let keys = Object.keys(controls);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            controls[key]["value"] = buffer[0][key] === null ? "" : buffer[0][key];
            controls[key]["valid"] = true;
            controls[key]["touched"] = false;
            controls[key]["showSpinner"] = false;
        }

        this.setState({controls: controls, errors: {}, updateBackgroundOperation: false});

        this.applet.setAction("Save Completed");
    };

    enterpriseComponentUpdateRollbackCompleted = (ec) => {
        let buffer = prepareBuffer(ec);
        buffer = buffer.slice(this.applet.getEnterpriseComponent().getRecordPointer(), this.applet.getEnterpriseComponent().getRecordPointer() + 1);

        let controls = this.makeControls().controls;

        let keys = Object.keys(controls);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            controls[key]["value"] = buffer[0][key] === null ? "" : buffer[0][key];
            controls[key]["valid"] = true;
            controls[key]["touched"] = false;
            controls[key]["showSpinner"] = false;
        }

        this.setState({controls: controls, errors: {}, updateBackgroundOperation: false});
    };

    evaluateSaveDisabledStatus() {
        if (this.useRealTimeReportingMethod()) {
            if (this.state.action === "Delete") {
                return false
            }
            return this.isFormValid() === false || this.isFormTouched() === false;
        } else {
            return false;
        }
    };

    getField(formElement, renderGroupRemoveButton, group) {
        let out;
        let field;

        if (formElement.csp === undefined) {
            formElement["csp"] = {};
        }
        if (formElement.ip === undefined) {
            formElement["ip"] = {};
        }

        if (formElement["placement"] === undefined) {
            formElement["placement"] = {
                "View": {order: 100, xs: 1, sm: 1, md: 1, lg: 1, xl: 1},
                "Edit": {order: 100, xs: 1, sm: 1, md: 1, lg: 1, xl: 1},
                "New": {order: 100, xs: 1, sm: 1, md: 1, lg: 1, xl: 1},
                "Delete": {order: 100, xs: 1, sm: 1, md: 1, lg: 1, xl: 1},
                "Query": {order: 100, xs: 1, sm: 1, md: 1, lg: 1, xl: 1}
            };
        }

        let attribute = this.applet.getEnterpriseComponent().getAttribute(formElement.enterpriseComponentAttribute);
        if (attribute !== undefined && attribute.getPicklist() !== null) {
            attribute.getPicklist().reevaluateMetadata()
        }

        formElement.csp.required = formElement.csp.required || (attribute === undefined ? false : attribute.getRequired());

        if (formElement.showWarning === true) {
            formElement.csp["helperText"] = formElement.warningText;
        } else {
            formElement.csp["helperText"] = null;
        }
        if (this.state.showErrors === true) {
            let helperText = formElement.csp["helperText"];

            formElement.csp["helperText"] = null;
            let keys = Object.keys(this.state.errors);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                if (key.includes(formElement.id)) {
                    helperText = this.state.errors[key];
                    formElement.csp["helperText"] = helperText;
                }
            }

            if (formElement.csp.required && helperText === null && !this.state.controls[formElement.id].valid) {
                formElement.csp["helperText"] = "Field must contain a value";
            }
        }

        let inputProps = {
            ...formElement.ip,
        };

        if (formElement.type === "Checkbox") {
            delete formElement.csp["helperText"];
        }

        let inputLabelProps = {shrink: true};

        if (formElement.longLabel) {
            inputLabelProps = {
                shrink: true,
                classes: {
                    root: css_self.LongLabel,
                },
            };
        }

        let adornments = {};
        let helpButton = null;
        let helpContent = null;
        let elementIndex = 0;
        if (formElement.help !== undefined && this.state.helpAnchor !== null) {
            helpContent = (
                <ClickAwayListener onClickAway={this.hideHelp}>
                    <Popper id={"1"} style={{zIndex: "4000"}} open={formElement.id === this.state.helpFormElementID} placement="right" anchorEl={this.state.helpAnchor}>
                        <Alert severity="info">
                            <>{formElement.help.map(element => (<React.Fragment key={elementIndex++}><span key={elementIndex++}>{element.helpText}</span><br /></React.Fragment>))}</>
                        </Alert>
                    </Popper>
                </ClickAwayListener>
            );
        }

        if (formElement.help !== undefined) {
            helpButton = (
                <IconButton style={{paddingRight: "0px"}} onClick={(event) => this.showHelp(event, formElement)}><Help color="primary" /></IconButton>
            );
            adornments["endAdornment"] = (
                <InputAdornment position="end">
                    {helpButton}
                    {helpContent}
                </InputAdornment>
            );
        }
        if (formElement.csp.uom !== undefined) {
            adornments["endAdornment"] = (
                <InputAdornment position="end">
                    <span style={{color: "#bac3ce"}}>{formElement.csp.uom}</span>
                    {helpButton}
                    {helpContent}
                </InputAdornment>
            );
        }
        if (formElement.showSpinner === true) {
            adornments["endAdornment"] = (
                <InputAdornment position="end">
                    <img src={spinner} alt="Spinner" style={{width: "35px", height: "35px"}} />
                </InputAdornment>
            );
        }
        if (!formElement.valid && formElement.touched && this.state.showErrors) {
            adornments["startAdornment"] = (
                <InputAdornment position="start">
                    <Error color="error" />
                </InputAdornment>
            );
        }
        if (formElement.valid && formElement.touched && this.state.showErrors) {
            adornments["startAdornment"] = (
                <InputAdornment position="start">
                    <CheckCircle color="primary" />
                </InputAdornment>
            );
        }
        if (formElement.type === "TextField") {
            let supplementalField;
            if (this.state.action === "Query") {
                adornments["startAdornment"] = null;
                supplementalField = (
                    <>
                        <IconButton className={css_button.filterIconButton} onClick={(e) => {this.setState({menu: {id: formElement.id, target: e.currentTarget}})}}>
                            <FilterAltOutlined />
                        </IconButton>
                        {this.state.menu?.id === formElement.id ? (
                            <Menu anchorEl={this.state.menu.target}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => this.setState({menu: null})}
                                  TransitionProps={{
                                      onExited: () => this.setState({menu: null}),
                                  }}>
                                <MenuItem key={formElement.id + "_contains"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Contains" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Contains"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_does_not_contain"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Does not contain" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Does not contain"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_equal_to"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is equal to" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is equal to"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_equal_to"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is not equal to" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is not equal to"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_starts_with"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Starts with" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Starts with"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_ends_with"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Ends with" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Ends with"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_null"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                   <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is null" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is null"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_null"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is not null" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is not null"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_empty"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is empty" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is empty"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_empty"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is not empty" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is not empty"/>
                               </MenuItem>
                            </Menu>
                        ) : null}
                    </>
                )
            }
            field = (
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <TextField
                        key={formElement.id}
                        {...formElement.csp}
                        error={!formElement.valid && formElement.touched && this.state.showErrors}
                        fullWidth={true}
                        id={formElement.id}
                        onBlur={(event) => this.blurHandler(event, formElement.id)}
                        onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                        value={formElement.value}
                        variant="outlined"
                        slotProps={{
                            inputLabel: inputLabelProps,
                            input: {
                                ...inputProps,
                                startAdornment: adornments["startAdornment"],
                                endAdornment: adornments["endAdornment"],
                            },
                        }}
                    />
                    {this.state.action === "Query" ? (
                        <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                            {supplementalField}
                        </div>
                    ) : null}
                </div>
            );
        }
        else if (formElement.type === "Search") {
            let supplementalField;
            if (this.state.action === "Query") {
                supplementalField = (
                    <>
                        <IconButton className={css_button.filterIconButton} onClick={(e) => {this.setState({menu: {id: formElement.id, target: e.currentTarget}})}}>
                            <FilterAltOutlined />
                        </IconButton>
                        {this.state.menu?.id === formElement.id ? (
                            <Menu anchorEl={this.state.menu.target}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => this.setState({menu: null})}
                                  TransitionProps={{
                                      onExited: () => this.setState({menu: null}),
                                  }}>
                                <MenuItem key={formElement.id + "_contains"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query"); this.setState({menu: null});}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Contains Keywords" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Contains Keywords"/>
                                </MenuItem>
                            </Menu>
                        ) : null}
                    </>
                )
            }
            if (this.state.action === "Query") {
                adornments["startAdornment"] = null
            }
            field = (
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%"}}>
                    <TextField
                        key={formElement.id}
                        {...formElement.csp}
                        error={!formElement.valid && formElement.touched && this.state.showErrors}
                        fullWidth={true}
                        id={formElement.id}
                        onBlur={(event) => this.blurHandler(event, formElement.id)}
                        onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                        value={formElement.value}
                        variant="outlined"
                        slotProps={{
                            inputLabel: inputLabelProps,
                            input: {
                                ...inputProps,
                                startAdornment: adornments["startAdornment"],
                                endAdornment: adornments["endAdornment"],
                            },
                        }}
                    />
                    {this.state.action === "Query" ? (
                        <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                            {supplementalField}
                        </div>
                    ) : null}
                </div>
            );
        }
        else if (formElement.type === "Placeholder") {
            field = null;
        }
        else if (formElement.type === "Phone") {
            field = (
                <CCInputPhone
                    key={formElement.id}
                    {...formElement.csp}
                    inputProps={inputProps}
                    InputLabelProps={inputLabelProps}
                    error={!formElement.valid && formElement.touched && this.state.showErrors}
                    id={formElement.id}
                    onBlur={(event) => this.blurHandler(event, formElement.id)}
                    onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                    value={formElement.value}
                    InputProps={adornments}
                />
            );
        }
        else if (formElement.type === "Integer") {
            field = (
                <CCInputInteger
                    key={formElement.id}
                    {...formElement.csp}
                    inputProps={inputProps}
                    InputLabelProps={inputLabelProps}
                    error={!formElement.valid && formElement.touched && this.state.showErrors}
                    id={formElement.id}
                    onBlur={(event) => this.blurHandler(event, formElement.id)}
                    onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                    value={formElement.value}
                    InputProps={adornments}
                />
            );
        }
        else if (formElement.type === "Select") {
            let supplementalField;
            let attribute = this.applet.getEnterpriseComponent().getAttribute(formElement.enterpriseComponentAttribute);

            let picklist = attribute !== null ? attribute.getPicklist() : null;

            if (this.state.action === "Query") {
                supplementalField = (
                    <>
                        <IconButton className={css_button.filterIconButton} onClick={(e) => {this.setState({menu: {id: formElement.id, target: e.currentTarget}})}}>
                            <FilterAltOutlined />
                        </IconButton>
                        {this.state.menu?.id === formElement.id ? (
                            <Menu anchorEl={this.state.menu.target}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => this.setState({menu: null})}
                                  TransitionProps={{
                                      onExited: () => this.setState({menu: null}),
                                  }}>
                                <MenuItem key={formElement.id + "_is_in"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query")}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is in" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is in"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_in"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query")}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is not in" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is not in"/>
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_null"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query")}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is null" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is null" />
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_null"} style={{height: "35px"}} onClick={(event) => {this.inputChangedHandler(event, formElement.id + "_query")}}>
                                    <ListItemIcon>
                                        {this.state.controls[formElement.id + "_query"].value === "Is not null" ? <Check /> : null}
                                    </ListItemIcon>
                                    <ListItemText primary="Is not null" />
                                </MenuItem>
                            </Menu>
                        ) : null}
                    </>
                )
            }

            if (this.state.action === "Query") {
                let v = [];
                if (formElement.value !== "" && Array.isArray(formElement.value) === false) {
                    v.push(formElement.value)
                } else if (Array.isArray(formElement.value)) {
                    v = formElement.value;
                }

                field = (
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                        <EnlilMultiSelect
                            key={formElement.id}
                            {...formElement.csp}
                            inputProps={inputProps}
                            InputLabelProps={inputLabelProps}
                            error={!formElement.valid && formElement.touched && this.state.showErrors}
                            fullWidth={true}
                            id={formElement.id}
                            onBlur={(event) => this.blurHandler(event, formElement.id)}
                            onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                            value={v}
                            variant="outlined"
                            InputProps={adornments}
                            picklist={picklist}
                            mode={this.state.action}
                            parent={this}
                        />
                        {this.state.action === "Query" ? (
                            <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                                {supplementalField}
                            </div>
                        ) : null}
                    </div>
                );
            }
            else {
                if (picklist.getLongList() === true) {
                    field = (
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <TextField
                                key={formElement.id}
                                {...formElement.csp}
                                error={!formElement.valid && formElement.touched && this.state.showErrors}
                                fullWidth={true}
                                id={formElement.id}
                                onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                                value={formElement.value}
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                    inputLabel: inputLabelProps
                                }}
                            />
                            <div style={{width: "40px", height: "40px", marginLeft: "5px"}}>
                                <IconButton className={css_button.filterIconButton} onClick={() => {this.setState({showLongSelect: true, longSelectPickList: picklist, longSelectAttribute: attribute, longSelectFormElementId: formElement.id})}}>
                                    <ListAlt />
                                </IconButton>
                            </div>
                            {this.state.action === "Query" ? (
                                <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                                    {supplementalField}
                                </div>
                            ) : null}
                        </div>
                    );
                } else {
                    field = (
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <EnlilSelect
                                key={formElement.id}
                                {...formElement.csp}
                                inputProps={inputProps}
                                InputLabelProps={inputLabelProps}
                                error={!formElement.valid && formElement.touched && this.state.showErrors}
                                fullWidth={true}
                                id={formElement.id}
                                onBlur={(event) => this.blurHandler(event, formElement.id)}
                                onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                                value={formElement.value}
                                variant="outlined"
                                InputProps={adornments}
                                picklist={picklist}
                                parent={this}
                                helperText={formElement.csp.helperText}
                            />
                            {this.state.action === "Query" ? (
                                <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                                    {supplementalField}
                                </div>
                            ) : null}
                        </div>
                    );
                }
            }
        }
        else if (formElement.type === "Number") {
            field = (
                <CCInputFloat
                    key={formElement.id}
                    {...formElement.csp}
                    inputProps={inputProps}
                    InputLabelProps={{shrink: true}}
                    error={!formElement.valid && formElement.touched && this.state.showErrors}
                    id={formElement.id}
                    onBlur={(event) => this.blurHandler(event, formElement.id)}
                    onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                    value={formElement.value}
                    InputProps={adornments}
                />
            );
        }
        else if (formElement.type === "Positive Float") {
            field = (
                <CCInputFloat
                    key={formElement.id}
                    {...formElement.csp}
                    inputProps={inputProps}
                    InputLabelProps={{shrink: true}}
                    error={!formElement.valid && formElement.touched && this.state.showErrors}
                    id={formElement.id}
                    onBlur={(event) => this.blurHandler(event, formElement.id)}
                    onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                    value={formElement.value}
                    InputProps={adornments}
                />
            );
        }
        else if (formElement.type === "Password") {
            adornments["endAdornment"] = (
                <InputAdornment position="end">
                    <IconButton onClick={() => this.toggleVisibility(formElement)}>
                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>
            );
            field = (
                <TextField
                    key={formElement.id}
                    {...formElement.csp}
                    inputProps={inputProps}
                    InputLabelProps={inputLabelProps}
                    error={!formElement.valid && formElement.touched && this.state.showErrors}
                    fullWidth={true}
                    id={formElement.id}
                    type={this.state.showPassword ? "text" : "password"}
                    onBlur={(event) => this.blurHandler(event, formElement.id)}
                    onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                    value={formElement.value}
                    variant="outlined"
                    slotProps={{
                        textField: {
                            helperText: formElement.csp.helperText,
                        },
                        input: {
                            startAdornment: adornments["startAdornment"],
                            endAdornment: adornments["endAdornment"],
                        },
                    }}
                />
            );
        }
        else if (formElement.type === "DateTime") {
            let supplementalField;
            let v = null;
            if (formElement.value) {
                v = moment(formElement.value);
            }

            if (this.state.action === "Query") {
                supplementalField = (
                    <>
                        <IconButton className={css_button.filterIconButton} onClick={(e) => {this.setState({menu: {id: formElement.id, target: e.currentTarget}})}}>
                            <FilterAltOutlined />
                        </IconButton>
                        {this.state.menu?.id === formElement.id ? (
                            <Menu anchorEl={this.state.menu.target}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => this.setState({menu: null})}
                                  TransitionProps={{
                                      onExited: () => this.setState({menu: null}),
                                  }}
                                  MenuListProps={{
                                      ...{"data-cc-component": "NavMenu"},
                                      disablePadding: true,
                                      style: {"minWidth": "100px"},
                                  }}
                            >
                                <MenuItem key={formElement.id + "_is_equal_to"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is equal to
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_equal_to"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is before
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_null"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is after
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_null"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is between
                                </MenuItem>
                            </Menu>
                        ) : null}
                    </>
                )
            }

            field = (
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <CCDateTimePicker
                        key={formElement.id}
                        {...formElement.csp}
                        fullWidth={true}
                        inputProps={inputProps}
                        error={!formElement.valid && formElement.touched && this.state.showErrors}
                        id={formElement.id}
                        onBlur={(event) => this.blurHandler(event, formElement.id)}
                        onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                        value={v}
                        InputLabelProps={inputLabelProps}
                        slotProps={{
                            textField: {
                                helperText: formElement.csp.helperText,
                            },
                            input: {
                                startAdornment: adornments["startAdornment"],
                                endAdornment: adornments["endAdornment"],
                            },
                        }}
                    />
                    {this.state.action === "Query" ? (
                        <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                            {supplementalField}
                        </div>
                    ) : null}
                </div>
            );
        }
        else if (formElement.type === "Date") {
            let supplementalField;
            let v = null;
            if (formElement.value) {
                v = moment(formElement.value);
            }
            if (this.state.action === "Query") {
                supplementalField = (
                    <>
                        <IconButton className={css_button.filterIconButton} onClick={(e) => {this.setState({menu: {id: formElement.id, target: e.currentTarget}})}}>
                            <FilterAltOutlined />
                        </IconButton>
                        {this.state.menu?.id === formElement.id ? (
                            <Menu anchorEl={this.state.menu.target}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => this.setState({menu: null})}
                                  TransitionProps={{
                                      onExited: () => this.setState({menu: null}),
                                  }}
                                  MenuListProps={{
                                      ...{"data-cc-component": "NavMenu"},
                                      disablePadding: true,
                                      style: {"minWidth": "100px"},
                                  }}
                            >
                                <MenuItem key={formElement.id + "_is_equal_to"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is equal to
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_equal_to"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is not equal to
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_null"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is null
                                </MenuItem>
                                <MenuItem key={formElement.id + "_is_not_null"} style={{height: "35px"}} onClick={(event) => {
                                    this.inputChangedHandler(event, formElement.id + "_query");
                                    this.setState({menu: null});
                                }}>
                                    Is not null
                                </MenuItem>
                            </Menu>
                        ) : null}
                    </>
                )
            }

            field = (
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <CCDatePicker
                        key={formElement.id}
                        id={formElement.id}
                        {...formElement.csp}
                        inputProps={inputProps}
                        onBlur={(event) => this.blurHandler(event, formElement.id)}
                        onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                        value={v}
                        InputLabelProps={inputLabelProps}
                        slotProps={{
                            textField: {
                                error: !formElement.valid && formElement.touched && this.state.showErrors,
                                required: formElement.csp.required,
                                helperText: formElement.csp.helperText,
                            },
                        }}
                    />
                    {this.state.action === "Query" ? (
                        <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px"}}>
                            {supplementalField}
                        </div>
                    ) : null}
                </div>
            );
        }
        else if (formElement.type === "Switch") {
            field = (
                <FormControlLabel
                    value="start"
                    control={<Switch
                        key={formElement.id}
                        {...formElement.csp}
                        id={formElement.id}
                        onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                        checked={formElement.value}
                    />
                    }
                    label={formElement.csp?.label}
                    labelPlacement={formElement.csp?.labelPlacement}
                />
            );
        }
        else if (formElement.type === "Checkbox") {
            field = (
                <FormControlLabel
                    key={formElement.id}
                    control={
                        <Checkbox
                            key={formElement.id}
                            inputProps={inputProps}
                            id={formElement.id}
                            onBlur={(event) => this.blurHandler(event, formElement.id)}
                            onChange={(event) => this.inputChangedHandler(event, formElement.id)}
                            checked={formElement.value === "true" || formElement.value === true}
                        />
                    }
                    {...formElement.csp}
                />
            );
        }

        let style = {};

        if (formElement.other?.marginBottom !== undefined) {
            style["marginBottom"] = formElement.other.marginBottom;
        } else {
            style["marginBottom"] = "1.0em";
        }

        if (formElement.other?.hidden === true) {
            style["display"] = "none";
        }

        let underNarrativeText = this.renderUnderNarrativeText(formElement);
        let assistiveText = this.renderAssistiveText(formElement);
        if (formElement.csp?.disabled === true) {
            assistiveText = null;
        }
        if (formElement.other?.renderAssistiveText === false) {
            assistiveText = null;
        }
        if (field === null) {
            assistiveText = null;
        }
        if (field !== null && (this.state.action === "Query")) {
            assistiveText = <Typography style={{fontSize: "12px", color: Grey6, marginLeft: "10px", marginTop: "4px"}}>{this.state.controls[formElement.id + "_query"].value}</Typography>
        }

        out = (
            <Grid wrap={"wrap"} style={{marginBottom: "0px", height: "90px"}} size={{xs: formElement["placement"][this.state.action].xs, sm: formElement["placement"][this.state.action].sm, md: formElement["placement"][this.state.action].md, lg: formElement["placement"][this.state.action].lg, xl: formElement["placement"][this.state.action].xl}}>
                {field}
                {!formElement.valid && formElement.touched && this.state.showErrors ? "" : assistiveText}
                {underNarrativeText}
            </Grid>
        );
        return out;
    };

    getGroups() {
        if (this.props.actions[this.state.action] !== undefined) {
            if (this.props.actions[this.state.action]["Groups"] === undefined) {
                return [];
            }
            return this.props.actions[this.state.action]["Groups"];
        }

        return [];
    };

    inputChangedHandler(event, inputIdentifier) {
        if (this.state.action === "View") return;

        let _value = null;

        if (event !== null) {
            if (this.state.controls[inputIdentifier].type === "Checkbox") {
                _value = event.target.checked;
            } else if (this.state.controls[inputIdentifier].type === "Phone") {
                _value = event.target.value.replace(/\D+/g, "").substring(0, 10);
            } else if (this.state.controls[inputIdentifier].type === "Switch") {
                _value = event.target.checked;
            } else if (this.state.controls[inputIdentifier].type === "DateTime") {
                _value = event;
            } else if (this.state.controls[inputIdentifier].type === "Date") {
                _value = event;
            } else if (inputIdentifier.includes("_query")) {
                _value = event.target.innerHTML;
            } else {
                _value = event.target.value;
            }
        }

        if (_value === "") _value = null;

        let updatedFormElement;
        let updatedObjectForm;

        let results = this.checkValidity(inputIdentifier, _value ?? "");
        let keys = Object.keys(this.state.controls);
        let formResults = {};

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (formResults[key] !== undefined) {
                continue;
            }

            let lengthWarningText = this.state.controls[key].lengthWarningText;

            if (_value !== null) {
                let attribute = this.applet.getEnterpriseComponent().getAttribute(this.state.controls[key].enterpriseComponentAttribute);
                if (attribute?.getName() === inputIdentifier) {
                    let length = attribute.getLength();
                    if (length !== null && _value.length === length) {
                        lengthWarningText = length + " characters allowed";
                    } else {
                        lengthWarningText = null;
                    }
                }
            }

            updatedFormElement = updateObject(this.state.controls[key], {
                value: results[key].value,
                valid: results[key].valid,
                touched: results[key].touched,
                hasBeenConfirmed: results[key].hasBeenConfirmed,
                lengthWarningText: lengthWarningText,
            });

            if (this.state.action === "Query") {
                if (inputIdentifier === key) {
                    if (this.applet.getEnterpriseComponent().getAttributeValue(inputIdentifier + "_query") === undefined || this.applet.getEnterpriseComponent().getAttributeValue(inputIdentifier + "_query") === "") {
                        if (this.state.controls[key].type === "TextField") {
                            this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier + "_query", "Contains");
                        } else if (this.state.controls[key].type === "Select") {
                            this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier + "_query", "Is in");
                        } else if (this.state.controls[key].type === "DateTime") {
                            this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier + "_query", "Is equal to");
                        } else if (this.state.controls[key].type === "Search") {
                            this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier + "_query", "Contains Keywords");
                        }
                    }
                    if (_value === null || _value.length === 0) {
                        formResults[key + "_query"] = updateObject(this.state.controls[key + "_query"], {
                            value: "",
                            valid: false,
                            touched: false,
                            hasBeenConfirmed: this.state.controls[key + "_query"].hasBeenConfirmed,
                            lengthWarningText: this.state.controls[key + "_query"].lengthWarningText
                        });
                        this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier + "_query", "")
                    }
                }
            }
            formResults[key] = updatedFormElement;
        }

        updatedObjectForm = updateObject(this.state.controls, formResults);

        let formIsValid = true;
        for (let inputIdentifier in updatedObjectForm) {
            formIsValid = updatedObjectForm[inputIdentifier].valid && formIsValid;
        }

        this.applet.getEnterpriseComponent().setAttributeValue(inputIdentifier, _value);

        let _state = {
            controls: updatedObjectForm,
            formIsValid: formIsValid,
            initialModification: true,
            showInitialModificationWarning: false,
        };

        if (this.isFieldInOnDemandGroup(inputIdentifier) === true && this.state.controls[inputIdentifier].value !== "") {
            _state["showAddAnother"] = true;
            this.setState(_state);
        } else {
            this.setState(_state);
        }

        if (this.timer !== null)  {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.triggerPostInputChangeHandler()
        }, 1000);
    };

    isFieldInOnDemandGroup = (inputIdentifier) => {
        for (let i = 0; i < this.props.actions[this.state.action].Groups.length; i++) {
            let group = this.props.actions[this.state.action].Groups[i];
            if (group["type"] === "ondemand") {
                for (let j = 0; j < group["increments"].length; j++) {
                    let increment = group["increments"][j];

                    for (let k = 0; k < increment.membership.length; k++) {
                        let member = increment.membership[k];
                        if (member.id === inputIdentifier) {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    };

    isFormTouched() {
        // eslint-disable-next-line no-unused-vars
        for (let formElementIdentifier in this.state.controls) {
            if (this.state.controls.hasOwnProperty(formElementIdentifier)) {
                if (this.state.controls[formElementIdentifier].touched === true) {
                    return true;
                }
            }
        }
        return false;
    };

    isFormValid = () => {
        // eslint-disable-next-line no-unused-vars
        let formIsValid = true;
        for (let formElementIdentifier in this.state.controls) {

            if (this.state.controls[formElementIdentifier].other?.hidden === true) continue;

            formIsValid = this.state.controls[formElementIdentifier].valid && formIsValid;

            let originalValue = false;

            if (this.state.action === "Edit") {
                if (this.applet.getEnterpriseComponent().getAttributeValue(formElementIdentifier, "original") === this.state.controls[formElementIdentifier].value) {
                    originalValue = true;
                }
            }

            if (this.state.controls[formElementIdentifier].requiresConfirmation &&
                this.state.controls[formElementIdentifier].hasBeenConfirmed === false &&
                this.state.controls[formElementIdentifier].value !== "" &&
                originalValue === false) {
                formIsValid = formIsValid && false;
            } else {
                formIsValid = formIsValid && true;
            }

        }
        return formIsValid;
    };

    makeControls() {
        let controlsForMode = [];
        let groupCounter = 0;

        let groups = this.getGroups();
        for (let i = 0; i < groups.length; i++) {
            let group = groups[i];
            if (group["type"] === "ondemand") {
                if (this.state.action === "View") {
                    groupCounter = 0;
                } else if (this.state.action === "Edit") {
                    groupCounter = 0;
                    this.setState({showAddAnother: true});
                } else groupCounter = 1;

                for (let j = 0; j < group["increments"].length; j++) {
                    let increment = group["increments"][j];

                    controlsForMode.push(...increment.membership);

                    let memberPresent = false;
                    for (let t = 0; t < increment["membership"].length; t++) {
                        let member = increment["membership"][t];
                        let control = this.props.controls[member.id];
                        let value = this.applet.getEnterpriseComponent().getAttributeValue(control.enterpriseComponentAttribute);
                        if (value !== null && value !== "") memberPresent = true;
                    }
                    if (memberPresent === true) groupCounter++;
                }
                if (groupCounter === group["increments"].length + 1) groupCounter = group["increments"].length;
            } else {
                controlsForMode.push(...group.membership);

                if (this.state.action === "Query") {
                    let query_controls = [];
                    for (let i = 0; i < controlsForMode.length; i++) {
                        let control = controlsForMode[i];

                        let c = structuredClone(control);
                        c["id"] = c.id + "_query"
                        query_controls.push(c);
                    }
                    controlsForMode.push(...query_controls);
                }
            }
        }

        let controls = {};
        for (let i = 0; i < controlsForMode.length; i++) {
            if (controlsForMode[i].id.includes("_query")) {
                controls[controlsForMode[i].id] = {
                    id: controlsForMode[i].id,
                    enterpriseComponentAttribute: controlsForMode[i].id,
                };
            } else {
                controls[controlsForMode[i].id] = this.props.controls[controlsForMode[i].id];
                if (controls[controlsForMode[i].id].placement === undefined) {
                    controls[controlsForMode[i].id].placement = {};
                }
                if (controls[controlsForMode[i].id].placement["View"] === undefined) {
                    controls[controlsForMode[i].id].placement["View"] = {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    };
                }
                if (controls[controlsForMode[i].id].placement["New"] === undefined) {
                    controls[controlsForMode[i].id].placement["New"] = {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    };
                }
                if (controls[controlsForMode[i].id].placement["Edit"] === undefined) {
                    controls[controlsForMode[i].id].placement["Edit"] = {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    };
                }
                if (controls[controlsForMode[i].id].placement["Query"] === undefined) {
                    controls[controlsForMode[i].id].placement["Query"] = {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    };
                }
            }
        }
        return {controls: controls, groupCounter: groupCounter};
    };

    onLongSelectCancelHandler = () => {
        this.setState({showLongSelect: false})
    };

    onLongSelectSelectHandler = (args) => {
        for (let i = 0; i < args.length; i++) {
            if (this.state.controls[args[i].attribute] !== undefined) {
                this.inputChangedHandler({
                    "target": {
                        value: args[i].value,
                    }
                }, args[i].attribute)
            }
        }
        this.setState({showLongSelect: false})
    };

    prepareLocalState(row) {
        let c = this.makeControls();
        let controls = c.controls;
        let groupCounter = c.groupCounter;

        if (this.state.action === "Save") {
            this.setState({controls: {}, groupCounter: 0, insertBackgroundOperation: true});
        } else if (this.state.action === "View") {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                if (controls[key]["csp"] === undefined) {
                    controls[key]["csp"] = {};
                }
                if (controls[key]["ip"] === undefined) {
                    controls[key]["ip"] = {};
                }

                let value = row.get(controls[key].enterpriseComponentAttribute) === null || row.get(controls[key].enterpriseComponentAttribute) === undefined ? "" : row.get(controls[key].enterpriseComponentAttribute);
                controls[key]["value"] = typeof value === "boolean" ? value : value.toString();
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
                controls[key]["passwordVisible"] = false;
                controls[key]["csp"]["disabled"] = true;
                controls[key]["ip"]["readOnly"] = true;
            }
            this.setState({controls: controls, groupCounter: groupCounter, insertBackgroundOperation: false});
        } else if (this.state.action === "Delete") {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                if (controls[key]["csp"] === undefined) {
                    controls[key]["csp"] = {};
                }
                if (controls[key]["ip"] === undefined) {
                    controls[key]["ip"] = {};
                }

                let value = row.get(controls[key].enterpriseComponentAttribute) === null || row.get(controls[key].enterpriseComponentAttribute) === undefined ? "" : row.get(controls[key].enterpriseComponentAttribute);
                controls[key]["value"] = typeof value === "boolean" ? value : value.toString();
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
                controls[key]["passwordVisible"] = false;
                controls[key]["csp"]["disabled"] = true;
                controls[key]["ip"]["readOnly"] = true;
            }
            this.setState({controls: controls, groupCounter: groupCounter, deleteBackgroundOperation: false});
        } else if (this.state.action === "Edit" || this.state.action === "Query") {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                if (controls[key]["csp"] === undefined) {
                    controls[key]["csp"] = {};
                }
                if (controls[key]["ip"] === undefined) {
                    controls[key]["ip"] = {};
                }

                let value = row.get(controls[key].enterpriseComponentAttribute) === null || row.get(controls[key].enterpriseComponentAttribute) === undefined ? "" : row.get(controls[key].enterpriseComponentAttribute);
                controls[key]["value"] = typeof value === "boolean" ? value : value.toString();
                controls[key]["valid"] = true;
                controls[key]["touched"] = false;
                controls[key]["showSpinner"] = false;
                controls[key]["passwordVisible"] = false;

                if (controls[key].enterpriseComponentAttribute !== null) {
                    let attribute = this.applet.getEnterpriseComponent().getAttribute(controls[key].enterpriseComponentAttribute);
                    if (attribute !== undefined) {
                        if (attribute.getLength() !== null) {
                            controls[key]["ip"]["maxLength"] = attribute.getLength();
                        }
                        if (attribute.getNoUpdate() !== null) {
                            if (controls[key]["csp"]["disabled"] === undefined) {
                                controls[key]["csp"]["disabled"] = attribute.getNoUpdate();
                            }
                            controls[key]["ip"]["readOnly"] = attribute.getNoUpdate();
                        }
                        if (attribute.getRequired() === true) {
                            let found = false;
                            for (let t = 0; t < controls[key]["errors"].length; t++) {
                                let err = controls[key]["errors"][t];
                                if (err.validator === "Required") found = true;
                            }
                            if (!found) {
                                controls[key]["errors"].push({
                                    validator: "Required",
                                    value: null,
                                    errorText: "Field must contain a value.",
                                });
                            }
                        }
                    }
                }

                if (controls[key]["requiresConfirmation"]) {
                    controls[key]["hasBeenConfirmed"] = true;
                    controls[key]["confirmedValue"] = value.toString();
                }
            }
            this.setState({controls: controls, formIsValid: true, groupCounter: groupCounter, insertBackgroundOperation: false});
        } else if (this.state.action === "New") {
            let keys = Object.keys(controls);
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                controls[key]["showSpinner"] = false;

                if (controls[key]["csp"] === undefined) {
                    controls[key]["csp"] = {};
                }
                if (controls[key]["ip"] === undefined) {
                    controls[key]["ip"] = {};
                }

                controls[key]["touched"] = false;
                let value = "";
                if (controls[key].type === "Date" || controls[key].type === "Datetime") {
                    value = null;
                }
                if (controls[key].enterpriseComponentAttribute !== null) {
                    let attribute = this.applet.getEnterpriseComponent().getAttribute(controls[key].enterpriseComponentAttribute);
                    if (attribute !== undefined) {
                        if (row.get(key) !== null) {
                            value = row.get(key);
                            controls[key]["touched"] = true;
                        } else {
                            if (attribute.getDefaultValue() !== null) {
                                value = attribute.getDefaultValue();
                            }
                            if (attribute.getLength() !== null) {
                                controls[key]["ip"]["maxLength"] = attribute.getLength();
                            }
                        }
                    }
                }

                let valid = true;
                if (controls[key].enterpriseComponentAttribute !== null) {
                    let attribute = this.applet.getEnterpriseComponent().getAttribute(controls[key].enterpriseComponentAttribute);
                    if (attribute !== undefined) {
                        if (attribute.getRequired() === true) {
                            valid = false;

                            if (this.applet.getEnterpriseComponent().getAttributeValue(attribute.getName()) !== null) {
                                valid = true;
                            }

                            let found = false;
                            for (let t = 0; t < controls[key]["errors"].length; t++) {
                                let err = controls[key]["errors"][t];
                                if (err.validator === "Required") found = true;
                            }
                            if (!found) {
                                controls[key]["errors"].push({
                                    validator: "Required",
                                    value: null,
                                    errorText: "Field must contain a value.",
                                });
                            }
                        }
                    }
                }
                controls[key]["valid"] = valid;
                controls[key]["passwordVisible"] = false;

                if (controls[key]["requiresConfirmation"]) {
                    controls[key]["hasBeenConfirmed"] = false;
                    controls[key]["confirmedValue"] = null;
                }

                if (controls[key].default !== undefined) {
                    if (controls[key].default["type"] === "Literal") {
                        value = controls[key].default["value"];
                    } else if (controls[key].default["type"] === "Computed") {
                        if (controls[key].default["value"] === "Now") {
                            let stillUtc = moment.utc();
                            value = moment(stillUtc).local().format("YYYY-MM-DDTHH:mm");
                        } else if (controls[key].default["value"] === "Employee USID") {
                            value = this.props.appContext.sessionContext.getEmployeeUSID();
                        } else if (controls[key].default["value"] === "Dynamic Lookup") {
                        } else {
                            value = this.getDefaultValue(controls[key].default["value"])
                        }
                    }
                    controls[key]["valid"] = true;
                    controls[key]["touched"] = true;
                    this.applet.getEnterpriseComponent().setAttributeValue(controls[key].enterpriseComponentAttribute, value);
                }

                controls[key]["value"] = value;

            }
            this.setState({controls: controls, formIsValid: true, groupCounter: groupCounter, insertBackgroundOperation: false});
        }
    };

    render() {
        return (
            <>
                {this.state.showLongSelect ? <EnlilLongSelect pickList={this.state.longSelectPickList} targetEnterpriseComponent={this.applet.getEnterpriseComponent()} targetEnterpriseComponentAttribute={this.state.longSelectAttribute} inputChangedHandler={this.inputChangedHandler} formElementId={this.state.longSelectFormElementId.formElementId}/> : null}
                {this.renderExtension()}
            </>
        );
    }

    renderExtension() {
        return null;
    };

    renderStandardGroup(group) {
        let formElements = [];
        let membership = group["membership"];
        for (let i = 0; i < membership.length; i++) {
            let f = this.state.controls[membership[i].id];
            if (f === undefined) console.log("Warning: Cannot find " + membership[i].id);
            else {
                formElements.push(this.getField(this.state.controls[membership[i].id]));
            }
        }

        return (
            <React.Fragment key={group.identifier}>
                {group["title"] !== undefined ? <div style={{marginLeft: "-13px", marginTop: "-15px"}}>{group["title"]}</div> : null}
                {formElements}
            </React.Fragment>
        );
    };

    renderAssistiveText(formElement) {
        if (formElement.csp.disabled) {
            return <Typography style={{fontSize: "14px", color: Grey6, marginLeft: "12px", marginTop: "4px"}}>Disabled</Typography>;
        }
        if (formElement.type !== "Select" && this.state.controls[formElement.id].lengthWarningText !== null && this.state.controls[formElement.id].lengthWarningText !== undefined) {
            return <Typography style={{fontSize: "14px", color: Grey6, marginLeft: "12px", marginTop: "4px"}}>{this.state.controls[formElement.id].lengthWarningText}</Typography>;
        }
        if (!formElement.csp.required && formElement.type !== "Checkbox") {
            return <Typography style={{fontSize: "14px", color: Grey6, marginLeft: "12px", marginTop: "4px"}}>Optional</Typography>;
        }
        /*
        if (formElement.csp.required && formElement.type !== "Checkbox") {
            return <Typography style={{fontSize: "12px", color: Grey6, marginLeft: "12px", marginTop: "4px"}}>Required</Typography>;
        }
        */
        return null;
    };

    renderUnderNarrativeText(formElement) {
        if (this.state.controls[formElement.id].underNarrativeText !== null && this.state.controls[formElement.id].underNarrativeText !== undefined) {
            return <Typography style={{fontSize: "12px", color: Grey6, marginLeft: "12px", marginTop: "4px"}}>{this.state.controls[formElement.id].underNarrativeText}</Typography>;
        }
        return null;
    };

    saveHandler() {
        if (this.useRealTimeReportingMethod() === true) {
            this.applet.save();
        } else {
            if (this.state.initialModification === false) {
                this.setState({showInitialModificationWarning: true});
            } else if (this.isFormValid() === true && this.isFormTouched() === false) {
                if (this.state.saveAndAddNew === true) {
                    this.applet.getView()?.initiateAction(this.props.saveAndNewAction);
                } else {
                    this.applet.cancel();
                }
            } else if (this.isFormValid() === false) {
                let keys = Object.keys(this.state.controls);
                let formResults = {};

                let updatedFormElement;
                let updatedObjectForm;

                for (let i = 0; i < keys.length; i++) {
                    let data = {
                        touched: true,
                    };
                    updatedFormElement = updateObject(this.state.controls[keys[i]], data);
                    formResults[keys[i]] = updatedFormElement;
                }
                updatedObjectForm = updateObject(this.state.controls, formResults);

                this.setState({controls: updatedObjectForm, showErrors: true});
            } else {
                if (this.props.options && this.props.options.ConfirmOnSave === true && this.state.confirmOnSave === true && this.state.performConfirmOnSave === false) {
                    this.setState({performConfirmOnSave: true});
                } else {
                    this.setState({performConfirmOnSave: false});
                    this.applet.save();
                }
            }
        }
    };

    triggerPostInputChangeHandler = () => {
    }

    useRealTimeReportingMethod() {
        if (this.state.errorReportingMethod === undefined) {
            return true;
        }
        return this.state.errorReportingMethod === "RealTime";
    };

    validatorFetchInitiated(formElementId, value) {
        let updatedFormElement = updateObject(this.state.controls[formElementId], {
            showSpinner: true,
            hasBeenConfirmed: false,
            confirmedValue: value,
        });
        let updatedObjectForm = updateObject(this.state.controls, {
            [formElementId]: updatedFormElement,
        });

        this.setState({controls: updatedObjectForm});
    };

    validatorFetchCompleted(formElementId, ec) {
        let check = false;

        let field = this.state.controls[formElementId];

        let err = field["errors"];

        let cumulativeErrors = {...this.state.errors};

        for (let i = 0; i < err.length; i++) {
            let testCase = err[i];

            if (testCase.validator === "Unique") {
                if (ec.getBuffer(ec.getPagePointer()).size > 0) {
                    check = true;
                }

                if (check === true) {
                    cumulativeErrors[field.id + "_" + testCase.validator] = testCase.errorText;
                } else {
                    delete cumulativeErrors[field.id + "_" + testCase.validator];
                }
            }
        }

        let updatedFormElement = updateObject(this.state.controls[formElementId], {
            showSpinner: false,
            valid: !check,
            hasBeenConfirmed: !check,
        });
        let updatedObjectForm = updateObject(this.state.controls, {
            [formElementId]: updatedFormElement,
        });

        this.setState({controls: updatedObjectForm, errors: cumulativeErrors});
    };

    validatorUnique(value, formElementId) {
        let validator = new UniqueValidator();

        let field = this.state.controls[formElementId];

        let attribute = this.applet.getEnterpriseComponent().getAttribute(field.enterpriseComponentAttribute);

        validator.validate(this, value, null, field, formElementId, attribute);

        return true;
    };

}

export default EnlilDetail;